import { render, staticRenderFns } from "./MyHubs.vue?vue&type=template&id=1fea87b6&"
import script from "./MyHubs.vue?vue&type=script&lang=js&"
export * from "./MyHubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports